module.exports = __webpack_public_path__ + "img/proyecto2.198b76eb.png";